var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.896,
    height: 74.899,
    viewBox: "0 0 79.896 74.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M100.234,239.406H47.178A7.186,7.186,0,0,1,40,232.227V194.46a2.5,2.5,0,1,1,4.994,0v37.768a2.187,2.187,0,0,0,2.185,2.185h53.056a2.187,2.187,0,0,0,2.185-2.185V194.46a2.5,2.5,0,1,1,4.994,0v37.768A7.186,7.186,0,0,1,100.234,239.406Z",
    transform: "translate(-33.759 -164.506)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M77.4,54.709a2.488,2.488,0,0,1-1.765-.731L44.583,22.925a6.561,6.561,0,0,0-9.269,0L4.262,53.977A2.5,2.5,0,0,1,.732,50.446L31.783,19.394a11.56,11.56,0,0,1,16.33,0L79.165,50.446A2.5,2.5,0,0,1,77.4,54.709Z",
    transform: "translate(0 -16.017)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M198.471,320.442H178.5a2.5,2.5,0,0,1-2.5-2.5V295.786a7.812,7.812,0,0,1,7.8-7.8h9.363a7.811,7.811,0,0,1,7.8,7.8v22.159A2.5,2.5,0,0,1,198.471,320.442Zm-17.477-4.994h14.981V295.786a2.812,2.812,0,0,0-2.809-2.809H183.8a2.812,2.812,0,0,0-2.809,2.809Z",
    transform: "translate(-148.537 -245.542)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.cf2ca7087f4b8f62f2cdd7a30256a167.svg";
export { ForwardRef as ReactComponent };